export default __webpack_public_path__ + "static/media/do_cennika1.e7239601.jpg";